import React, { useState } from 'react';

import { ApproveDailyReportModal } from 'modules/components/layer17';
import { CustomIcon } from 'modules/components/layer00';
import { WeatherSummaryCard } from 'modules/components/layer20';
import { ActivityHeaderSectionWithMetricsLayout } from 'modules/components/layer32';

import * as ds from './dataService';
import {
  Button,
  useTheme
} from '@mui/material';

import {
  useNavigate,
  useParams
} from 'react-router-dom';


export type DailyReportHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DailyReportHeaderSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '', params.dailyReportId ?? '');
  return (
    <ActivityHeaderSectionWithMetricsLayout.FC
      title={data.reportDate?.toFormat('DDDD') ?? ''}
      subtitle=''
      actionButtons={(
        <ActionButtonsGroup
          id={data.id}
          isApproved={data.isApproved}
          todayReportId={data.todayReportId}
          nextReportId={data.nextReportId}
          previousReportId={data.previousReportId}
        />
      )}
      metrics={(
        <WeatherSummaryCard.FC
          address={data.addressFull}
          name={data.name}
          weather={data.weather}
          numberOfIncidents={data.accidents.count}
          numberOfInspections={data.inspections.count}
        />
      )}
    />
  );
};


type ActionButtonsGroup = {
  id: string;
  isApproved: boolean;
  todayReportId: string;
  nextReportId: string;
  previousReportId: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {
        isVisible && (
          <ApproveDailyReportModal.FC
            id={props.id}
            isVisible={isVisible}
            handleClose={() => setIsVisible(() => false)}
          />
        )
      }
      <Button
        variant='contained'
        disabled={props.isApproved}
        onClick={() =>
          setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='CHECKFLAT'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Approve Report
      </Button>
      <Button
        variant='contained'
        sx={{
          bgcolor: theme.palette.primary.light,
          color: theme.palette.primary.main
        }}

        onClick={() =>
          navigate(
            '..'
          )}
        startIcon={(
          <CustomIcon.large.FC
            icon='CALENDARALT'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        List View
      </Button>
      <Button
        variant='contained'
        sx={{
          bgcolor: theme.palette.primary.light,
          color: theme.palette.primary.main
        }}
        disabled={props.previousReportId === props.id}
        onClick={() =>
          navigate(
            `../${props.previousReportId}`
          )}
        startIcon={(
          <CustomIcon.medium.FC
            icon='CHEVRONLEFT'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Previous
      </Button>
      <Button
        variant='contained'
        sx={{
          bgcolor: theme.palette.primary.light,
          color: theme.palette.primary.main
        }}
        disabled={props.nextReportId === props.id}
        onClick={() =>
          navigate(
            `../${props.nextReportId}`
          )}
        endIcon={(
          <CustomIcon.medium.FC
            icon='CHEVRONRIGHT'
            stroke={theme.palette.primary.main}
          />
        )}
      >
        Next
      </Button>
    </>
  );
};

